import OnboardingLogin from './OnboardingLogin';
import OnboardingReviu from './OnboardingReviu';

export default function Component(props) {
    const { tipus } = props;

    switch (tipus) {
        case 'reviu':
            return <OnboardingReviu {...props} />;
        default:
            return <OnboardingLogin {...props} />;
    }
}
